import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import ClaimedDomains from './claimed-domains';

import { openCollectionTab } from '../../dashboard/actions/collection-action-creators';
import { fetchClaimedDomainsIfNeeded } from '../actions/claimed-domains-action-creators';


import { claimedDomainHierarchyParamSelector } from './claimed-domains-selectors';
export class ClaimedDomainsContainer extends Component{
    componentDidMount(){
        const {
            fetchClaimedDomainsIfNeeded,
            match: { params: { collectionId } },
            openCollectionTab
        } = this.props;

        // the container uses dynamic collection tab navigation structure, so this needs to
        // match the child canvas in collection-config
        const tabMeta = {
            id: 'claimed-domains',
            name: 'Claimed Domains',
            url: `/${collectionId}/claimed-domains`
        };

        openCollectionTab( this.props, tabMeta );

        fetchClaimedDomainsIfNeeded();
    }

    componentDidUpdate( prevProps ){
        const { fetchClaimedDomainsIfNeeded, location: { search } } = this.props;

        // only fetch default claimed domains when changing b/w parent & subdomain tables
        if( prevProps.location.search !== search ){
            fetchClaimedDomainsIfNeeded();
        }
    }

    render(){
        const {
            domainHierarchyParam,
            match,
        } = this.props;

        if( match.params.collectionId !== 'system' ){
            return <Redirect to={{ pathname: `/collections/system` }} />;
        }

        return (
            <ClaimedDomains
                match={match}
                selectedDomainFilter={domainHierarchyParam}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        domainHierarchyParam: claimedDomainHierarchyParamSelector( state ),
    };
};

const mapDispatchToProps = {
    fetchClaimedDomainsIfNeeded,
    openCollectionTab
};

ClaimedDomainsContainer.propTypes = {
    domainHierarchyParam: PropTypes.string,
    fetchClaimedDomainsIfNeeded: PropTypes.func.isRequired,
    location: PropTypes.shape( {
        search: PropTypes.string
    } ),
    match: PropTypes.shape( {
        params: PropTypes.shape( {
            collectionId: PropTypes.string
        } ),
        url: PropTypes.string,
    } ),
    openCollectionTab: PropTypes.func.isRequired,
};

export default connect( mapStateToProps, mapDispatchToProps )( ClaimedDomainsContainer );
